export const InstagramIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.33784 12C6.33784 8.59671 9.09671 5.83784 12.5 5.83784C15.9033 5.83784 18.6622 8.59671 18.6622 12C18.6622 15.4033 15.9033 18.1622 12.5 18.1622C9.09671 18.1622 6.33784 15.4033 6.33784 12ZM12.5 16C10.2908 16 8.5 14.2092 8.5 12C8.5 9.79085 10.2908 8 12.5 8C14.7091 8 16.5 9.79085 16.5 12C16.5 14.2092 14.7091 16 12.5 16Z"
        fill="white"
      />
      <path
        d="M18.9056 7.03436C19.7009 7.03436 20.3456 6.38968 20.3456 5.59438C20.3456 4.79909 19.7009 4.15436 18.9056 4.15436C18.1104 4.15436 17.4656 4.79909 17.4656 5.59438C17.4656 6.38968 18.1104 7.03436 18.9056 7.03436Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 0C9.241 0 8.83234 0.0138139 7.55242 0.0722133C6.27516 0.13047 5.40283 0.333343 4.63954 0.630008C3.85044 0.936629 3.18123 1.34695 2.51406 2.01406C1.84695 2.68123 1.43663 3.35044 1.13001 4.13954C0.833343 4.90283 0.63047 5.77516 0.572213 7.05242C0.513814 8.33234 0.5 8.741 0.5 12C0.5 15.259 0.513814 15.6677 0.572213 16.9476C0.63047 18.2248 0.833343 19.0972 1.13001 19.8605C1.43663 20.6496 1.84695 21.3188 2.51406 21.9859C3.18123 22.6531 3.85044 23.0634 4.63954 23.37C5.40283 23.6667 6.27516 23.8695 7.55242 23.9278C8.83234 23.9862 9.241 24 12.5 24C15.759 24 16.1677 23.9862 17.4476 23.9278C18.7248 23.8695 19.5972 23.6667 20.3605 23.37C21.1496 23.0634 21.8188 22.6531 22.4859 21.9859C23.1531 21.3188 23.5634 20.6496 23.87 19.8605C24.1667 19.0972 24.3695 18.2248 24.4278 16.9476C24.4862 15.6677 24.5 15.259 24.5 12C24.5 8.741 24.4862 8.33234 24.4278 7.05242C24.3695 5.77516 24.1667 4.90283 23.87 4.13954C23.5634 3.35044 23.1531 2.68123 22.4859 2.01406C21.8188 1.34695 21.1496 0.936629 20.3605 0.630008C19.5972 0.333343 18.7248 0.13047 17.4476 0.0722133C16.1677 0.0138139 15.759 0 12.5 0ZM12.5 2.16216C15.7041 2.16216 16.0837 2.1744 17.349 2.23213C18.519 2.28548 19.1544 2.48097 19.5773 2.64531C20.1374 2.863 20.5371 3.12303 20.957 3.54297C21.377 3.96287 21.637 4.36261 21.8547 4.92274C22.019 5.34559 22.2145 5.98098 22.2679 7.15097C22.3256 8.41632 22.3378 8.79587 22.3378 12C22.3378 15.2041 22.3256 15.5837 22.2679 16.849C22.2145 18.019 22.019 18.6544 21.8547 19.0773C21.637 19.6374 21.377 20.0371 20.957 20.457C20.5371 20.877 20.1374 21.137 19.5773 21.3547C19.1544 21.519 18.519 21.7145 17.349 21.7679C16.0839 21.8256 15.7044 21.8378 12.5 21.8378C9.29563 21.8378 8.91618 21.8256 7.65097 21.7679C6.48098 21.7145 5.84559 21.519 5.42275 21.3547C4.86262 21.137 4.46287 20.877 4.04298 20.457C3.62308 20.0371 3.363 19.6374 3.14531 19.0773C2.98098 18.6544 2.78549 18.019 2.73214 16.849C2.6744 15.5837 2.66216 15.2041 2.66216 12C2.66216 8.79587 2.6744 8.41632 2.73214 7.15097C2.78549 5.98098 2.98098 5.34559 3.14531 4.92274C3.363 4.36261 3.62304 3.96287 4.04298 3.54297C4.46287 3.12303 4.86262 2.863 5.42275 2.64531C5.84559 2.48097 6.48098 2.28548 7.65097 2.23213C8.91632 2.1744 9.29587 2.16216 12.5 2.16216Z"
        fill="white"
      />
    </svg>
  );
};

export const FacebookIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <circle cx="12.5" cy="12" r="10.5" fill="white" />
      <path
        d="M16.4103 15.2112L16.8767 12.2476H13.9589V10.3252C13.9589 9.51428 14.3657 8.7233 15.6726 8.7233H17V6.20024C17 6.20024 15.7959 6 14.6452 6C12.2411 6 10.6712 7.4197 10.6712 9.98883V12.2476H8V15.2112H10.6712V22.3759C11.2075 22.458 11.7562 22.5 12.3151 22.5C12.874 22.5 13.4226 22.458 13.9589 22.3759V15.2112H16.4103Z"
        fill="#0866FF"
      />
    </svg>
  );
};
